<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefaultBig modalText="兑换CDK" :showModal="showModal" @close="close()" @confirm="confirm()" modalspan="福利中心"
      :showCancel="false" :showConfirm="false">
      <template #dialogContent>
        <div class="tab-box">
          <div @click="changeTab(2)" :class="[curTab == 2 ? 'sel' : '']" class="tab-item">
            口令红包
          </div>
          <div @click="changeTab(0)" :class="[curTab == 0 ? 'sel' : '']" class="tab-item">
            CDK
          </div>
          <div @click="changeTab(1)" :class="[curTab == 1 ? 'sel' : '']" class="tab-item">
            充值红包
          </div>
        </div>
        <div class="welfare-content">
          <div class="red-packet" v-if="fuli_index == 0">
            <!-- <div class="key-label">兑换CDK</div> -->
            <div class="key-input">
              <span>请输入CDK</span>
              <input v-model="cdk_code" placeholder="输入CDK" />
            </div>
            <div class="bottom-bottom">
              <div class="opt-btn btn-2 blue" @click="doExchange">
                <span style="color: rgb(255, 255, 255)">CDK兑换</span>
              </div>
            </div>
          </div>
          <div class="red-packet" v-if="fuli_index == 2">
            <!-- <div class="key-label">兑换CDK</div> -->
            <div class="key-input">
              <span>请输入红包口令</span>
              <input v-model="redPackKey" placeholder="输入CDK" />
            </div>
            <div class="bottom-bottom">
              <div class="opt-btn btn-2 blue" @click="getRedPack">
                <span style="color: rgb(255, 255, 255)">领取红包</span>
              </div>
            </div>
          </div>
          <div class="red-packet" v-if="fuli_index == 1">
            <!-- <div class="key-label">充值红包</div> -->
            <div class="red-packet-list">
              <div class="red-packet-item" v-for="(item, index) in redPacketList" :key="index">
                <div class="item-title">
                  充值{{ item.recharge }}送{{ item.bonus }}
                  <img src="../../assets/images/balance2.png" alt="" style="width: 20px; height: 20px;" />
                </div>
                <div class="item-btn" v-if="!item.hasClaimed" @click="doRecharge(item)">领取</div>
                <div class="item-btn" v-if="item.hasClaimed">已领取</div>
              </div>
            </div>
          </div>
          <!-- <div v-if="fuli_index == 2" class="consume-reward"> -->
          <div v-if="false" class="consume-reward">
            <div class="top-total-box">
              <div class="total-box-1">
                <span>今日消费：</span>
                <span class="price">{{ welfare_info.totalAmount }}</span>
              </div>
              <div class="total-box-2">
                <span class="vip appFont">{{ user.level_info.name }}</span>
                <!-- <image src="/static/images/vip/0.png" alt="" class="vip"></image> -->
                <span>奖励比例:</span>
                <span class="percent">{{ user.level_info.sale_reward }}%</span>
              </div>
            </div>
            <div class="reward-box">
              <div class="reward-price">
                <span>{{ welfare_info.todaySaleReward }}</span>
              </div>
              <div class="time">次日 自动发放</div>
            </div>
            <div class="last-date-reward">
              <span>昨日奖励：</span><span class="price">{{ welfare_info.yesterdaySaleReward }}</span>
            </div>
            <div class="rule-desc-box">
              <div class="rule-title"><span>活动规则：</span></div>
              <div class="rule-span">
                <p>用户通过盲盒消费 [G币] 可获得奖励</p>
                <p>消费福利：当日消费 * 当前奖励比例</p>
                <p>
                  每笔消费福利按日统计结算，单笔奖励低于0.01不结算，当日奖励次日自动发放
                </p>
              </div>
            </div>
            <div class="bottom-tip-box">
              <div>VIP等级越高奖励越多</div>
              <img @click="openLevelDesc" src="/static/images/question2-icon.png" alt="" class="desc-img" />
            </div>
            <div class="common-small-dialog-wrap vip-detail-dialog">
              <!---->
            </div>
          </div>
          <div v-if="fuli_index == 3" class="fq-reward">
            <div class="top-box">
              <div class="month">
                <span class="num">03</span><span class="span">月限时</span>
              </div>
            </div>
            <div class="total-box">
              <div class="span-info">
                <div>当月消费：<span class="border">0</span></div>
                <div>当月获得：<span class="border">0</span></div>
                <div>非酋积分：<span class="border">0 积分</span></div>
                <div>
                  积分<span>每月结算</span>为G币奖励并<span>逐月发放</span>至余额
                </div>
                <img src="/static/images/question2-icon.png" alt="" class="desc-icon" />
              </div>
            </div>
            <div class="table-mouth-wrap">
              <div class="title">你的本月积分</div>
              <div class="point">0</div>
              <img src="/static/images/icon-detail.png" alt="" class="desc-icon" />
              <div class="table-box">
                <div class="table-header">
                  <div class="col">结算</div>
                  <div class="col">预计获得</div>
                </div>
                <div class="table-body">
                  <div class="td-item">
                    <div class="col">2024-04</div>
                    <div class="col col1">
                      <span>0</span>
                      <img src="/static/images/balance1.png" alt="" class="icon" />
                    </div>
                  </div>
                  <div class="td-item">
                    <div class="col">2024-05</div>
                    <div class="col col1">
                      <span>0</span>
                      <img src="/static/images/balance1.png" alt="" class="icon" />
                    </div>
                  </div>
                  <div class="td-item">
                    <div class="col">2024-06</div>
                    <div class="col col1">
                      <span>0</span>
                      <img src="/static/images/balance1.png" alt="" class="icon" />
                    </div>
                  </div>
                  <div class="td-item">
                    <div class="col">2024-07</div>
                    <div class="col col1">
                      <span>0</span>
                      <img src="/static/images/balance1.png" alt="" class="icon" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mouth-price flex-center">
                <span>本月已发：</span>0
                <img src="/static/images/balance1.png" alt="" class="icon" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- <template #bottomTab>
        <div @click="changeTab(0)" :class="[curTab == 0 ? 'sel' : '']" class="tab-item">
          CDK
        </div>
        <div @click="changeTab(1)" :class="[curTab == 1 ? 'sel' : '']" class="tab-item">
          充值红包
        </div>
      </template> -->
    </modalDefaultBig>
  </div>
</template>
<script>
import {
  kamiPay,
  userRechargeBonus,
  getUserInfo,
  userHasRechargeBonus,
  redPack
} from "@/api/index";
import modalDefaultBig from "@/components/common/modalDefaultBig.vue";
export default {
  name: "modalBoxDetail",
  components: {
    modalDefaultBig,
  },
  data() {
    return {
      cdk_code: "",
      redPackKey:"",
      fuli_index: 2,
      curTab: 2,
      redPacketList: [
        {
          recharge: 200,
          bonus: 5.8,
        },
        {
          recharge: 2000,
          bonus: 28.8,
        },
        {
          recharge: 10000,
          bonus: 58.8,
        },
      ],
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    // info: {
    //   type: Object,
    //   default: {},
    // },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.fuli_index = 2;
        this.curTab = 2;
        this.getUserHasRechargeBonus();
        // this.dropLists = [];
        // this.getDrop();
      }
    },
  },
  methods: {
    changeTab(type) {
      this.curTab = type;
      this.fuli_index = type;
      this.getUserHasRechargeBonus()
    },
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
    // 兑换
    doExchange() {
      kamiPay({ password: this.cdk_code }).then((res) => {
        // debugger
        if (res.data.code == 200) {
          this.cdk_code = "";
          getUserInfo().then((res) => {
            if (res.data.code == 200) {
              this.$store.commit("USER_INFO", res.data.data);
            }
          });
          this.$message({
            duration: 1000,
            type: "success",
            message: "领取成功",
            customClass: "log_success",
          });
        }
      });
    },
    // 领取红包
    getRedPack() {
      redPack({ redPackKey: this.redPackKey }).then((res) => {
        // debugger
        if (res.data.code == 200) {
          this.redPackKey = "";
          getUserInfo().then((res) => {
            if (res.data.code == 200) {
              this.$store.commit("USER_INFO", res.data.data);
            }
          });
          this.$message({
            duration: 1000,
            type: "success",
            message: "成功领取"+res.data.data.receiveAmount+"红包",
            customClass: "log_success",
          });
        }
      });
    },
    doRecharge(item) {
      userRechargeBonus({
        recharge: item.recharge,
        bonus: item.bonus,
      }).then((res) => {
        if (res.data.code == 200) {
          // setTimeout(() => {
          getUserInfo().then((res) => {
            if (res.data.code == 200) {
              this.$store.commit("USER_INFO", res.data.data);
            }
          });
          this.getUserHasRechargeBonus()
          this.$message({
            duration: 1000,
            type: "success",
            message: "领取成功",
            customClass: "log_success",
          });
          // this.$emit("close");
          // },1000)
        } else {
          this.$message({
            duration: 1000,
            type: "error",
            message: "领取失败",
            customClass: "log_warning",
          });
        }
      });
    },
    // 获取已经领取列表
    getUserHasRechargeBonus() {
      userHasRechargeBonus({}).then((res) => {
        if (res.data.code == 200) {
          this.redPacketList.forEach((item) => {
            item.hasClaimed = res.data.data.includes(
              String(item.recharge)
            );
          });
          console.log(this.redPacketList, '红包列表');
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.goods-info .box-info {
  position: relative;
  height: 15.2 * 4.2px;
  margin-top: 4 * 4.2px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 98.67 * 4.2px 13.33 * 4.2px;
  background-image: url("../../assets/images/info_bk4.png");
}

.goods-info .box-info .info-item {
  float: left;
  width: 37.6 * 4.2px;
  height: 12.27 * 4.2px;
  margin-left: 5.07 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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);
}

.goods-info .box-info .info-item .img-box {
  position: relative;
  float: left;
  width: 11.47 * 4.2px;
  height: 11.47 * 4.2px;
}

.goods-info .box-info .info-item .img-box .img {
  -o-object-fit: scale-down;
  object-fit: scale-down;
  margin: 0.27 * 4.2px 0 0 0.93 * 4.2px;
}

.goods-info .box-info .info-item .name-box {
  float: left;
  width: 20 * 4.2px;
  color: #96b0ff;
  padding-left: 4.27 * 4.2px;
}

.goods-info .box-info .info-item .name-box .type {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 3.33 * 4.2px;
  margin-top: 2.4 * 4.2px;
}

.goods-info .box-info .info-item .name-box .name {
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 2.67 * 4.2px;
  margin-top: 1px;
}

.goods-info .box-info .price-box {
  float: right;
  width: 37.07 * 4.2px;
  height: 7.47 * 4.2px;
  margin: 3.2 * 4.2px 5.07 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiwAAABwCAMAAAAKett+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURYiU/4WF5j5HiEtWnlBXjUBFbT9DagAAAIuX/4WX+YeZ/0BKi4yb/0pUnU1YoYqX/4ya/jxGhj9Iij1Ih4ub/4uZ/4qW/z9IiYqY/0dQlomX/46d/4qY/4WU+IaS/0ROkkBJjDtEg0ZQloiY/4qY/4uZ/4qY/z9Day02boiW/YSR9oiW/q3J/4iX/oOQ84mX/YiX/oiX/YaU+XyI5oGO8Iyb/4WX/4qX/09YoXJ90YWT+ImX/4mX/0JHcDhBf4mX/i01bnmF3kVPloqY/ztEhIqY/UBKjDpDgfm7PUFGb1VcloiX/mNts3yI5kdRl46d/4OQ84mW/dmxeIqY/4mW/oqX/2t1wneD3T1HhzE6dYqY/zQ9eoKQ8qehzISS9oGO8HiE3nqG4omX/zE6dH2N6kRKdnWB2E1Xooqb/3uH5IGR+36Q/0xWoIOS/ktVnn+L7EhTmoKP8YuX/4qZ/2x2xYaU+oCN7oGN7nKD6n+N7XB7zEBKjIeT/oqZ/zxDaD1Ea1xko296zH6L609Yjoua//66PYqY/2hxvS01bXSB1oeV+0NNkIqY/oOQ83J+0jI6dThBf36K6jhBf4qZ/nmI7u61WPm5RTxFa4SS94mX/TI6dk9Yj0VKd0pPgFVblYiW+5KS9jdAfTg/bdSug2RstNaugIOQ9EpQgIGO8FJalISR9WBorFdeml5nqVxkpHuH42x2xHB7zFtioS85cmZuuC42cDdAfniF2zpBZ3mF305VinmE3lhgnTU/eHiE3jxGhYCN74uZ//q7P4OQ83+L6XqG4U1ViVBapGJqsS84cYiV/IaU+UhRl0FKimlyvt2xcNmxcYKQ8jQ9cu+2U0tYmjxFh8eqmPC4T4ya/3+L6ICM6nmF37alsve6Q09ao05Xnzc/e0hSmTY9blJakU1YoUZQlj1Ghk5YokxXoP+6O05YoUtVnklSmkdSmEVPlENNkUFLjk5Zo0lUnEZQl0xWoIKP8YWS9n+M7DpEg09apE5XoHqH4lBapIiW/X2J509ao90lCEkAAAD5dFJOUysC/0RwzuIALCwnRVK97WkQ/P79ISkV7jRFN8THcAq9/vrvL0lOOuLSPs9fAUBjl85DznBwLyxwQ3DjZjLO9VvaW/5FvBzvu8jicPZwzb2+44piwuNicM6827voyDf0+HDNV+MOzs2+Evfizu5v7s7uzjCozvdc487Izr4tn9vJcFv3ba71tM6g41PvefHNOj/i75Bvlc7Ci4CtaOLOzskFtbZZzl6q4rTim87i4s7j4uLiy+PA1zvRyM6DzoTi5+2D1P6V9OIg4sXXxSxT4mdjgZKYE0xRoX5Ta6FBvK+KXfng1f///////////////////////////m9VQdwAAAjJSURBVHja7d1/XNR3Acfx72Hz0KjBUHIU5JpjeJy/+DVFlk6jLHfFzO2yweFNU+zHCBWYRFlrRl5Bma2hlRI6wtumG7A5czKQWQSKzC215rb+cE5d6syJKZv2+X4+35/385sPjvtcez+B87iHf/l9Pd6fu5OHCuYIY62PvfnQ6udXE89TP9AZPvx2veGcu93LF336neKPkj9T26gniWbiKaKrq6u1tbW3t/dp4hliLdXW1raDWEdUEPlUjmK+1ty581dMH2kif9x5D7i7HUQNkS9EWiym5ISpexoeaxA9plituPOGyHSnD9/w8nvFn5hNzAvEduIJ0datW6uJlUQlUVu7hLDb7U6n02YroUoJiyidmazVPX/uB3Mn3zOh2Go2J9y2vrusn+jsvFgkRF4ro3Ye+K3ix1of+b/zJZ9+qHO3xn2KaZKFkgwqU5akdYfehhXdH4i1zI41m5NHudzd/VItQuS1MlrIHgEjsnWiB1Fi2qTJ6rYUz65Ld9BYaoQIbAVCLHGGVIu4LdbiKXUWR+TFglaGqha2LZvZtsTSWiIsFrQyVLI9tmUCqSWyYkEr4d2Wzgh6NYRWwrEt6XXKthRFzrKglbBsS5myLW6LRUArEGhbytLrptBtcbndAlqBANtSJtZCtyVvXLmAViDAtqSXydtiSkgQ0AoE2haxFgvbFrOAViDItvQ72LZEQixoJdzb0u9g2yKgFTCwLRayLSYBrUCwbbE4+h2ldeNHCWgFgm2Lm9RSU1o3UUArEHRb3JaazpqCRgGtgKFt6aypENAKGNmWfM5/Bhet8LMtSRa+Y0ErHEkr4DoWtMKTGVzHgla4MpHnWNAKb7Fc5DYWtIJY0ApiQSuIBa2AJpZLPMaCVhALWon0WB4W0ApEaixohddYLnEXC1pBLGgFsaCVD08sqziLBa0gFrSCWAaZFa0gFqPq0QpiMSoWrXAey1V+YslDK4jFqJFohe9Yrl5dxk0saAWxIBbEEoJjCBcEsSAWxIJYPmSx2K4OIBZALDC4ym0DiAUMLotzYGAfYoHgqhIzybIMIBYILrH8pR1YFjC0K+Uv2ZYN7GtDLGBgV2z7Bvbteg2xQGC3prBd2bX7LsQCgaVIu7J7Zx5igcDGSbuyc7EJsUCQt+OapFY4+o8eEAuvb8fZWCtmM2KBwKL/YVvmpLuCWCBoLM4dr9FdQSwQLJYMp3Mh3RXEAsFj2XUXawWxQLBY7Lv+bkYsYCwWO5YFjMdiQixgJJaF9iWIBQzGsgSxAGIBxAJhjKUWsYDBWGprf4RYALHAIMdSWYlYwFgs0xALIBYIQSwrEQsYjGUlYgHEAogFwhdLdTViAcQCOIYgbO/g4u1+MBpLBn5SDgzH8hB+BheCGFF4+PEtx4ToXyMWCKbw8VdeP7JFELSxmBgrYgHdrmx5dO+avQfFWJyesYS9FsTC2a48+ps1pxALGNoV0sqpOfN8xhL2Ywj/3xB3u8JiyXiIv5fOuELc7YoUC4fvswjREMRQ7wq3y1I/+tZgli9fnpsrfpFb8quMfsuMUSUyKTrjJRMkU6jZ1DiN22QuV0yMK8blcj0gmSFJU92rNd2HGwfD9HvT0lzjq4Z0V+TnLNy9z5I8csyY3Fzvi+55/aXLnqijliAXoF5+5brHyJdcudrs2rKLcQfzc2aDqKPjHtF60STq+8wKySOinyi+rvNVHz51nTYTPT09jTcORS3qrvAbS97o6NGB0CHOysqia5KVpY5zFnswVw5KsyK0nNke4cSI5GjkZZCa0RZz9OjRjg4WzHq/wTwi0xXzFT8+ef0m55T15zQmTagawl3xfjXEyzGUHFsc60uxRL2XkFDsJcFTXkKel1F6IyWaGGl5WeLRNibXY8tSlONLPbp0Z5f2+FLEDJbpk9JJLU1Jod4W7a5wGwsEZF08fsNmR8i3Rb8riCVSLU7p6HH054d0W0bod0WOxcZbLK/un+rbsBC5+fp9NDR+qfULrf2v1pvMdFs6cxozQ7YthccOHtl7Sou93W8r5yyW/W8uVX1sEH3Zj0//777n4Wu+fM6vL/jzB8VGyU91Du3521/qTdbFKRt6HJ35TZmh2pbCea/sXaOLZU6fIGRyF4t12NL3RdeI8+ffJk6fflty2sPJk1d0TlLHj5/08o7OvxX/Is4oLlyY5dNbxJkz4u2sWWeZc9S7orGSm24in1S8JC5O/PJ2SwCfpX5F3E8sWrRowYIFM4nU1NSZqS0NpJZkui09NRfbG0NUSxWJ5fU5OkcOk1hKuFuWYUsvi7Fcvnz+PItFpN6Tkzmuwb5joci0qbxHaZPR56Imc4F6S6Lek53VtvKujKUiivLrhAH/UbBipFyImZKWjXsOSNtSUHSxIlTbsvzYlr6DffMUfX2HC4XszJJVvMUydenla9dCHcs7hmPRPyKGMkuJRe5l7Fh1XTzFx8tbExfYLfLg0FmRluX+BVQq00I+N8rb8nIB25Yhe+9fmFhSwmEs719jqWhzYeQ41Fy80/EO5j2Jr8PIXyxnz+qXRX6UDYtuW6ROWCrxLBHxwzApl3jlhFJqkVphubTQG2VbXi4oukS3JTo7Ozv0f/kUXZXJXyz0GOI7lnPnfCyLFEtUlLwpUQHJR4/mflzUibgT4qf+JKLHEDuIUsWvZw8dIC+KrGRbVj18qb1p97S7FfcppskWSjKoTEVSQN/xQh50t5eWW7mLRU1FH4sahxrIlSvH/fI8iPzHoj7F1R46Puie33o8w/U6hMQQ1Gjk770z8tqYOPpEl40Le46rHEXkaW4D2ZZkqzU2kdZir96+adMLxHbiCWIrUU2sJCorK2tra5cQdrvd6bQRJaJSiUUjXeNbXiylpRVFBbz92/1T3/j4oPm23oMevuvhM4b8jHyQW43P+/SJ6/Qi89yLzzEtxF9Fz0oaDv1zP3naYsord69rX7e2tXnbtieJ5ubmp4iurq5Worf3aeIZYi3VRuwg1okqmHxFjodveqK/q71pinSR/gtSyrK9w1LW1wAAAABJRU5ErkJggg==);
}

.goods-info .box-info .price-box .price {
  float: right;
  display: inline-block;
  height: 6.93 * 4.2px;
  line-height: 6.93 * 4.2px;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  color: #ffe3c2;
  margin: 0.4 * 4.2px 2.93 * 4.2px 0 0.67 * 4.2px;
}

.goods-info .box-info .price-box .coin {
  float: right;
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  margin: 2 * 4.2px 2.93 * 4.2px 0 0;
}

.goods-info .box-info .total-box {
  position: relative;
  float: right;
  width: 20.4 * 4.2px;
  height: 6 * 4.2px;
  font-size: 3.33 * 4.2px;
  margin: 5.33 * 4.2px 5.07 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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);
}

.goods-info .box-info .total-box .pre-span {
  position: absolute;
  top: -4.67 * 4.2px;
  left: 0;
  width: 20.4 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  color: #96b0ff;
  span-align: center;
}

.goods-info .box-info .total-box .total {
  width: 100%;
  height: 6 * 4.2px;
  line-height: 6 * 4.2px;
  color: #96b0ff;
  span-align: center;
}

.goods-info .goods-list {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 90.4 * 4.2px;
  height: 86.13 * 4.2px;
  margin: 5.6 * 4.2px 0 5.87 * 4.2px 4.93 * 4.2px;
  padding: 1.6 * 4.2px 0 0 2.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/goods_list_bk1.png");
}

.goods-info .goods-list .list-inner {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  height: 81.2 * 4.2px;
  overflow-y: scroll;
  padding: 2.67 * 4.2px 0 0 0px;
}

.goods-info .goods-list .list-inner::-webkit-scrollbar {
  width: 0.67 * 4.2px;
  height: 0.67 * 4.2px;
}

.goods-info .goods-list .list-inner::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.goods-info .goods-list .list-inner::-webkit-scrollbar-track {
  -webkit-border-radius: 0;
  border-radius: 0;
  background: transparent;
}

.goods-info .goods-list .total-head {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 84.53 * 4.2px;
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  span-align: center;
  font-size: 3.33 * 4.2px;
  color: #bbc3ff;
  margin: 2 * 4.2px 0 0.67 * 4.2px 0.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABPQAAABYBAMAAACABrTaAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURYeW/wAAAIaU/4mJ/4WW/4WZ/2aZ/4eX/4ec/4CA/4CS/4CX/4Cq/4WX/4aU/9PQIIcAAAAPdFJOUzMAJg0uGQUxJAIOIAYsE6vSfpwAAAFJSURBVHja7dSxCcIAFEXR4AYiCIKFhQu4gWPYu4BLuUN6F0iRFaxcwiYLiOhtzp3gwz+8Yb20f02Dvmh12hzc9UmLvN31csYHvYDe9n684YPe/+kZPfQiekYPvYae0UMvomf00GvoGT30InpGD72GntFDL6Jn9NBr6Bk99CJ6Rg+9hp7RQy+iZ/TQazJ66EUZPfSiHkYPvaan0UOvaTR66DXNRg89oYee0BN66Ak9oYee0JMXo4eeu+TF6KHnLqEn9NATekIPPaEn9NATevJi9ISevBg99NwlL0YPPXcJPaGHntATeugJPaGHntCTF6Mn9OTF6KHnLnkxeui5S+gJPfSEntBDT+gJPfSEnrwYPaEnL0YPPXfJi9FDz11CT+ihJ/SEHnpCT+ihJ/TkxegJPXkxeui5S+ihh567hJ7QQ0/oCT30hN4vewNL7GRgE1Ru0QAAAABJRU5ErkJggg==);
}

.goods-info .goods-list .total-head .item1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.goods-info .goods-list .total-head .item2 {
  width: 20 * 4.2px;
}

.goods-info .goods-list .total-head .item3 {
  width: 20 * 4.2px;
}

.goods-info .goods-list .total-list {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  height: 72 * 4.2px;
  overflow-y: scroll;
  padding: 0.27 * 4.2px 0 0 0.4 * 4.2px;
}

.goods-info .goods-list .total-list::-webkit-scrollbar {
  width: 0.67 * 4.2px;
  height: 0.67 * 4.2px;
}

.goods-info .goods-list .total-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.goods-info .goods-list .total-list::-webkit-scrollbar-track {
  -webkit-border-radius: 0;
  border-radius: 0;
  background: transparent;
}

.goods-info .goods-list .total-list .total-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 84.53 * 4.2px;
  height: 10.67 * 4.2px;
  background-size: 100% 100%;
  margin: 0 0 1.07 * 4.2px 0;
}

.goods-info .goods-list .total-list .total-item.color\#FFA500 {
  background-image: url("../../assets/images/item_golden.png");
}

.goods-info .goods-list .total-list .total-item.color\#FF4500 {
  background-image: url("../../assets/images/item_red.png");
}

.goods-info .goods-list .total-list .total-item.color\#8a2be2 {
  background-image: url("../../assets/images/item_purple.png");
}

.goods-info .goods-list .total-list .total-item.color\#007acc {
  background-image: url("../../assets/images/item_blue.png");
}

.goods-info .goods-list .total-list .total-item .item-column1 {
  position: relative;
  width: 14.13 * 4.2px;
  margin-left: 1.33 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column1 .goods-img {
  width: 90%;
  height: 90%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.goods-info .goods-list .total-list .total-item .item-column1 .tag {
  position: absolute;
  left: 0.4 * 4.2px;
  bottom: 0.4 * 4.2px;
  // width: 6.67*4.2px;
  height: 3.2 * 4.2px;
  line-height: 3.2 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 2.67 * 4.2px;
  line-height: 4 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column2 .name {
  width: 25.33 * 4.2px;
  height: 4 * 4.2px;
  margin-top: 1.07 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column2 .price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 4 * 4.2px;
  margin-top: 0.67 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column2 .price .coin {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column3 {
  width: 17.33 * 4.2px;
  line-height: 4 * 4.2px;
  span-align: right;
  padding-right: 0.67 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column3 .award {
  margin-top: 1.33 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column3 .num {
  margin-top: 0.4 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column4 {
  width: 17.33 * 4.2px;
  line-height: 4 * 4.2px;
  span-align: right;
  padding-right: 0.67 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column4 .award {
  margin-top: 1.33 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column4 .num {
  margin-top: 0.4 * 4.2px;
}

.goods-info .goods-list .total-list .total-item .item-column5 {
  width: 4.27 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/sum_bk2.png");
}

.goods-info .goods-list .total-list .total-item .item-column5.active {
  background-image: url("../../assets/images/sum_bk1.png");
}

.prod-level {
  display: inline-block;
  height: 11.33 * 4.2px;
  color: #96b0ff;
  font-size: 3.33 * 4.2px;
}

.prod-level .pre-color {
  width: 2.67 * 4.2px;
  height: 2.67 * 4.2px;
  margin-right: 2.67 * 4.2px;
  display: inline-block;
}

.prod-level .pre-color.color\#FFA500 {
  background: #9f7e36;
}

.prod-level .pre-color.color\#FF4500 {
  background: #9b265f;
}

.prod-level .pre-color.color\#8a2be2 {
  background: #7526ab;
}

.prod-level .pre-color.color\#007acc {
  background: #274cad;
}

.prod-level .percentage {
  margin: 4.67 * 4.2px 0 0 0;
}

.prod-level .percentage .level {
  width: 20 * 4.2px;
}

.prod-level .level3 {
  padding-right: 2 * 4.2px;
}

.prod-level .level2 {
  padding-right: 2 * 4.2px;
}

.prod-level .level1 {
  padding-right: 2 * 4.2px;
}

.prod-level span {
  display: inline-block;
}

.prod-level .arr-progress {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 83.47 * 4.2px;
  height: 4.93 * 4.2px;
  margin: 0.8 * 4.2px 0 0 0px;
  padding: 1.53 * 4.2px 0 0 1.87 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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);
}

.prod-level .arr-progress .arr-item {
  width: 0.53 * 4.2px;
  height: 1.33 * 4.2px;
  margin-right: 0.27 * 4.2px;
  background: #0e64cb;
}

.prod-level .arr-progress .arr-item.color\#FFA500 {
  background: #ffc437;
}

.prod-level .arr-progress .arr-item.color\#FF4500 {
  background: #ff3782;
}

.prod-level .arr-progress .arr-item.color\#8a2be2 {
  background: #bd37ff;
}

.prod-level .arr-progress .arr-item.color\#007acc {
  background: #3772ff;
}

.prod-info {
  position: relative;
  width: 28.13 * 4.2px;
  height: 25.87 * 4.2px;
  margin: 0 0.67 * 4.2px 1.07 * 4.2px 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/item_blue2.png");
}

.prod-info.golden {
  background-image: url("../../assets/images/item_golden2.png");
}

.prod-info.red {
  background-image: url("../../assets/images/item_red2.png");
}

.prod-info.purple {
  background-image: url("../../assets/images/item_purple2.png");
}

.prod-info.blue {
  background-image: url("../../assets/images/item_blue2.png");
}

.prod-info .img-box {
  width: 28.13 * 4.2px;
  height: 19.33 * 4.2px;
}

.prod-info .img-box .img {
  width: 90%;
  height: 90%;
  margin-top: -8%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.prod-info .info-aw {
  position: absolute;
  bottom: 9.73 * 4.2px;
  left: 0;
  font-size: 3.33 * 4.2px;
  padding: 0 0 0 1.33 * 4.2px;
}

.prod-info .info-name {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  bottom: 5.73 * 4.2px;
  left: 0;
  width: 100%;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  padding: 0 1.33 * 4.2px;
}

.prod-info .info-price {
  position: absolute;
  bottom: 0.8 * 4.2px;
  right: 1.6 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 3.73 * 4.2px;
  font-weight: 700;
  color: #ffe2c0;
}

.prod-info .info-price .coin {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
}

.prod-info .tag-level {
  position: absolute;
  top: 0.8 * 4.2px;
  right: 0px;
  width: 12.4 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  span-align: center;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  color: #fff;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAeBAMAAAC8kw8yAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN0S+bUAAAANdFJOU4B8AHpAB353CHlFfURIGHGkAAAAT0lEQVQ4y2MoFCQFFDAkMJACEhgESFIvMKp+VP2oehLUbyBR/QQS1S8mUX2LAWnqVZ1JU68UYkCaepIsAKonyQKQelIsSACqV+qZSHx5CwDE0BIOEbf6gAAAAABJRU5ErkJggg==);
}

.tab-box {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 3.33 * 4.2px;
  color: #FFFFFF;
  line-height: 3.81 * 4.2px;
  text-align: center;
  font-style: normal;
  text-transform: none;

  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 4.76 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
    line-height: 3.81vw;
    margin: 4.76vw;
  }
}

.tab-box .tab-item {
  width: 18.26 * 4.2px;
  height: 7.28 * 4.2px;
  background: url("../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 1 * 4.2px;
  color: #7a7a7a;

  @media only screen and (max-width: 430px) {
    width: 18.26vw;
    height: 7.28vw;
    background-size: 18.26vw 7.28vw;
    margin-right: 1vw;
  }
}

.tab-box .tab-item.sel {
  background: url("../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    background-size: 18.26vw 7.28vw;
  }
}

.welfare-content {
  // height: 126.67 * 4.2px;
  height: 49 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    height: 49vw
  }
}

.red-packet {
  // width: 100%;
  // padding-top: 5.07 * 4.2px;
  // height: 103.07 * 4.2px;
  // padding-bottom: 33.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 430px) {
    // width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

.red-packet .key-label {
  margin-top: 17.33 * 4.2px;
  font-size: 5.6 * 4.2px;
  color: #a6bbff;
  text-align: center;
}

.red-packet .key-input {
  width: 88%;
  height: 25 * 4.2px;
  background-color: #302077;
  border-radius: 5px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  padding: 2.38 * 4.2px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 88%;
    height: 25vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 2.38vw;
  }
}

.red-packet .key-input input {
  width: 100%;
  height: 8 * 4.2px;
  background-color: #031543;
  line-height: 8.13 * 4.2px;
  font-size: 3.33 * 4.2px;
  border-radius: 4px;
  margin-top: 2.38 * 4.2px;
  padding-left: 2.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 100%;
    height: 8vw;
    line-height: 8.13vw;
    font-size: 3.33vw;
    margin-top: 2.38vw;
    padding-left: 2.38vw;
  }
}

.red-packet .bottom-bottom {
  width: 100%;
  height: 8.13 * 4.2px;
  margin-top: 4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;

  @media only screen and (max-width: 430px) {
    width: 100%;
    height: 8.13vw;
    margin-top: 4vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}

.consume-reward {
  width: 100%;
  padding: 10.67 * 4.2px 10.67 * 4.2px 0 13.33 * 4.2px;
  height: 112.13 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url("../../assets/images/k33.png") no-repeat 7.07 * 4.2px 7.07 * 4.2px;
  background-size: 85.87 * 4.2px 104.27 * 4.2px;
}

.consume-reward .top-total-box {
  width: 73.87 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/text_bg.png") no-repeat -6.67 * 4.2px 0;
  background-size: 73.87 * 4.2px 5.47 * 4.2px;
  padding-left: 1.73 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.47 * 4.2px;
  white-space: nowrap;
  color: #b4c5ff;
}

.consume-reward .top-total-box view {
  padding-bottom: 2.67 * 4.2px;
}

.consume-reward .top-total-box .price {
  color: #eec88b;
}

.consume-reward .top-total-box .vip {
  font-size: 4.4 * 4.2px;
  color: #eec88b;
}

.consume-reward .top-total-box .total-box-1 {
  width: 37.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.consume-reward .top-total-box .total-box-2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.consume-reward .top-total-box .total-box-2 image {
  margin-top: -0.67 * 4.2px;
  margin-right: 1.33 * 4.2px;
  width: 12 * 4.2px;
  height: 4.67 * 4.2px;
}

.consume-reward .top-total-box .total-box-2 .percent {
  color: #48e538;
}

.consume-reward .reward-box {
  width: 73.87 * 4.2px;
  height: 20.4 * 4.2px;
  background: url("../../assets/images/box_bg.png") no-repeat 0 0;
  background-size: 73.87 * 4.2px 20.4 * 4.2px;
  margin-top: 4.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.consume-reward .reward-box .reward-price {
  font-family: "Alimama ShuHeiTi", serif;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #eec88b;
  font-size: 8.93 * 4.2px;
}

.consume-reward .reward-box .reward-price .bi {
  width: 5.6 * 4.2px;
  height: 5.07 * 4.2px;
  margin-right: 2.27 * 4.2px;
}

.consume-reward .reward-box .time {
  font-size: 2.67 * 4.2px;
  color: #6f87a5;
}

.consume-reward .last-date-reward {
  width: 100%;
  height: 4 * 4.2px;
  font-size: 3.33 * 4.2px;
  padding-top: 4.53 * 4.2px;
}

.consume-reward .last-date-reward .price {
  color: #eec88b;
}

.consume-reward .rule-desc-box {
  width: 73.87 * 4.2px;
  padding-top: 7.33 * 4.2px;
  padding-bottom: 2.67 * 4.2px;
}

.consume-reward .rule-desc-box .rule-title {
  width: 100%;
  height: 7.47 * 4.2px;
  background: url("../../assets/images/line10.png") no-repeat 0 bottom;
  background-size: 100% 1px;
  padding-left: 1.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 4.4 * 4.2px;
}

.consume-reward .rule-desc-box .rule-text {
  padding: 2.67 * 4.2px 3.33 * 4.2px 1.33 * 4.2px;
  margin-top: 2.67 * 4.2px;
  font-size: 3.2 * 4.2px;
  background: url("../../assets/images/k34.png") no-repeat;
  background-size: 100% 100%;
}

.consume-reward .rule-desc-box .rule-text p {
  margin-bottom: 2.53 * 4.2px;
}

.consume-reward .bottom-tip-box {
  width: 100%;
  height: 6.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.33 * 4.2px;
  color: #6796f6;
  padding-top: 1.87 * 4.2px;
}

.consume-reward .bottom-tip-box .desc-img {
  width: 6.53 * 4.2px;
  height: 6.67 * 4.2px;
  margin-left: 2.53 * 4.2px;
}

.consume-reward .vip-detail-dialog .van-dialog {
  padding-top: 13.33 * 4.2px;
}

.consume-reward .vip-detail-dialog .vip-rule-detail {
  padding-top: 4 * 4.2px;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-text {
  width: 71.6 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/vip_dialog_top_bg.png") no-repeat 0 0;
  background-size: 71.6 * 4.2px 5.47 * 4.2px;
  margin: 0 auto;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  text-align: center;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box {
  width: 73.33 * 4.2px;
  height: auto;
  margin: 0 auto;
  padding-top: 4.4 * 4.2px;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .reward-rule-title {
  width: 73.33 * 4.2px;
  height: 7.6 * 4.2px;
  background: url("../../assets/images/vip_dialog_table_header_bg.png") no-repeat 0 0;
  background-size: 73.33 * 4.2px 7.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .reward-rule-title>view {
  float: left;
  line-height: 7.6 * 4.2px;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .col-1 {
  width: 31.73 * 4.2px;
  height: 7.6 * 4.2px;
  margin-right: 0.53 * 4.2px;
  text-align: center;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .col-2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 7.6 * 4.2px;
  text-align: center;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item {
  width: 73.33 * 4.2px;
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item.sel:before {
  content: "";
  width: 73.33 * 4.2px;
  height: 6.13 * 4.2px;
  background: url("../../assets/images/vip_dialog_tb_item_sel.png") no-repeat 0 0;
  background-size: 73.33 * 4.2px 6.13 * 4.2px;
  position: absolute;
  left: 0;
  top: -0.27 * 4.2px;
  z-index: 5;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item>view {
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  position: relative;
  z-index: 10;
}

.consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item:after {
  content: "";
  display: block;
  width: 71.47 * 4.2px;
  height: 1px;
  background: url("../../assets/images/line11.png") no-repeat 0 0;
  background-size: 71.47 * 4.2px 1px;
  position: absolute;
  left: 0.93 * 4.2px;
  bottom: 0;
  z-index: 2;
}

.consume-reward .vip-detail-dialog .bottom-btn-wrap {
  width: 100%;
  height: auto;
  padding-bottom: 8 * 4.2px;
  padding-top: 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.opt-btn {
  width: 38vw;
  height: 8.8vw;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 38vw 8.8vw;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.opt-btn text {
  margin-top: 0.53vw;
}

.opt-btn.red {
  background-image: url("../../assets/images/del_confirm_btn.png");
}

.opt-btn.btn-2 {
  width: 40.27vw;
  height: 8.8vw;
  background-size: 40.27vw 8.8vw;
  font-size: 4vw;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
}

.opt-btn {
  width: 38 * 4.2px;
  height: 8.8 * 4.2px;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 38 * 4.2px 8.8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.opt-btn text {
  margin-top: 0.53 * 4.2px;
}

.opt-btn.red {
  background-image: url("../../assets/images/del_confirm_btn.png");
}

.opt-btn.btn-2 {
  width: 40.27 * 4.2px;
  height: 8.8 * 4.2px;
  background-size: 40.27 * 4.2px 8.8 * 4.2px;
  font-size: 4 * 4.2px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
}

.red-packet-list {
  width: 80%;
  // margin: 20px auto;
  color: #a6bbff;
}

.red-packet-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-bottom: 2.38vw;
  }
}

.red-packet-item .item-title {
  width: 60%;

  @media only screen and (max-width: 430px) {
    width: 60%;
  }
}

.red-packet-item .item-btn {
  width: 14.29 * 4.2px;
  height: 4.76 * 4.2px;
  line-height: 4.76 * 4.2px;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 100% 100%;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 14.29vw;
    height: 4.76vw;
    line-height: 4.76vw;
    font-size: 3.33vw;
  }
}

@media only screen and (max-width: 430px) {
  .opt-btn {
    width: 38vw;
    height: 8.8vw;
    background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
    background-size: 38vw 8.8vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .opt-btn text {
    margin-top: 0.53vw;
  }

  .opt-btn.red {
    background-image: url("../../assets/images/del_confirm_btn.png");
  }

  .opt-btn.btn-2 {
    width: 40.27vw;
    height: 8.8vw;
    background-size: 40.27vw 8.8vw;
    font-size: 4vw;
    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  }

  .red-packet .key-label {
    margin-top: 17.33vw;
    font-size: 5.6vw;
    color: #a6bbff;
    text-align: center;
  }

  .consume-reward {
    width: 100%;
    padding: 10.67vw 10.67vw 0 13.33vw;
    height: 112.13vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: url("../../assets/images/k33.png") no-repeat 7.07vw 7.07vw;
    background-size: 85.87vw 104.27vw;
  }

  .consume-reward .top-total-box {
    width: 73.87vw;
    height: 5.47vw;
    background: url("../../assets/images/text_bg.png") no-repeat -6.67vw 0;
    background-size: 73.87vw 5.47vw;
    padding-left: 1.73vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 3.47vw;
    white-space: nowrap;
    color: #b4c5ff;
  }

  .consume-reward .top-total-box view {
    padding-bottom: 2.67vw;
  }

  .consume-reward .top-total-box .price {
    color: #eec88b;
  }

  .consume-reward .top-total-box .vip {
    font-size: 4.4vw;
    color: #eec88b;
  }

  .consume-reward .top-total-box .total-box-1 {
    width: 37.33vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .consume-reward .top-total-box .total-box-2 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .consume-reward .top-total-box .total-box-2 image {
    margin-top: -0.67vw;
    margin-right: 1.33vw;
    width: 12vw;
    height: 4.67vw;
  }

  .consume-reward .top-total-box .total-box-2 .percent {
    color: #48e538;
  }

  .consume-reward .reward-box {
    width: 73.87vw;
    height: 20.4vw;
    background: url("../../assets/images/box_bg.png") no-repeat 0 0;
    background-size: 73.87vw 20.4vw;
    margin-top: 4.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .consume-reward .reward-box .reward-price {
    font-family: "Alimama ShuHeiTi", serif;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: #eec88b;
    font-size: 8.93vw;
  }

  .consume-reward .reward-box .reward-price .bi {
    width: 5.6vw;
    height: 5.07vw;
    margin-right: 2.27vw;
  }

  .consume-reward .reward-box .time {
    font-size: 2.67vw;
    color: #6f87a5;
  }

  .consume-reward .last-date-reward {
    width: 100%;
    height: 4vw;
    font-size: 3.33vw;
    padding-top: 4.53vw;
  }

  .consume-reward .last-date-reward .price {
    color: #eec88b;
  }

  .consume-reward .rule-desc-box {
    width: 73.87vw;
    padding-top: 7.33vw;
    padding-bottom: 2.67vw;
  }

  .consume-reward .rule-desc-box .rule-title {
    width: 100%;
    height: 7.47vw;
    background: url("../../assets/images/line10.png") no-repeat 0 bottom;
    background-size: 100% 1px;
    padding-left: 1.6vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 4.4vw;
  }

  .consume-reward .rule-desc-box .rule-text {
    padding: 2.67vw 3.33vw 1.33vw;
    margin-top: 2.67vw;
    font-size: 3.2vw;
    background: url("../../assets/images/k34.png") no-repeat;
    background-size: 100% 100%;
  }

  .consume-reward .rule-desc-box .rule-text p {
    margin-bottom: 2.53vw;
  }

  .consume-reward .bottom-tip-box {
    width: 100%;
    height: 6.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 3.33vw;
    color: #6796f6;
    padding-top: 1.87vw;
  }

  .consume-reward .bottom-tip-box .desc-img {
    width: 6.53vw;
    height: 6.67vw;
    margin-left: 2.53vw;
  }

  .consume-reward .vip-detail-dialog .van-dialog {
    padding-top: 13.33vw;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail {
    padding-top: 4vw;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-text {
    width: 71.6vw;
    height: 5.47vw;
    background: url("../../assets/images/vip_dialog_top_bg.png") no-repeat 0 0;
    background-size: 71.6vw 5.47vw;
    margin: 0 auto;
    font-size: 3.33vw;
    color: #a6bbff;
    text-align: center;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box {
    width: 73.33vw;
    height: auto;
    margin: 0 auto;
    padding-top: 4.4vw;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .reward-rule-title {
    width: 73.33vw;
    height: 7.6vw;
    background: url("../../assets/images/vip_dialog_table_header_bg.png") no-repeat 0 0;
    background-size: 73.33vw 7.6vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .reward-rule-title>view {
    float: left;
    line-height: 7.6vw;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .col-1 {
    width: 31.73vw;
    height: 7.6vw;
    margin-right: 0.53vw;
    text-align: center;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .col-2 {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 7.6vw;
    text-align: center;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item {
    width: 73.33vw;
    height: 5.87vw;
    line-height: 5.87vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item.sel:before {
    content: "";
    width: 73.33vw;
    height: 6.13vw;
    background: url("../../assets/images/vip_dialog_tb_item_sel.png") no-repeat 0 0;
    background-size: 73.33vw 6.13vw;
    position: absolute;
    left: 0;
    top: -0.27vw;
    z-index: 5;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item>view {
    height: 5.87vw;
    line-height: 5.87vw;
    font-size: 3.33vw;
    color: #a6bbff;
    position: relative;
    z-index: 10;
  }

  .consume-reward .vip-detail-dialog .vip-rule-detail .vip-reward-rule-box .rule-item:after {
    content: "";
    display: block;
    width: 71.47vw;
    height: 1px;
    background: url("../../assets/images/line11.png") no-repeat 0 0;
    background-size: 71.47vw 1px;
    position: absolute;
    left: 0.93vw;
    bottom: 0;
    z-index: 2;
  }

  .consume-reward .vip-detail-dialog .bottom-btn-wrap {
    width: 100%;
    height: auto;
    padding-bottom: 8vw;
    padding-top: 5.33vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .goods-info .box-info {
    height: 15.2vw;
    margin-top: 4vw;

    background-size: 98.67vw 13.33vw;
  }

  .goods-info .box-info .info-item {
    width: 37.6vw;
    height: 12.27vw;
    margin-left: 5.07vw;
  }

  .goods-info .box-info .info-item .img-box {
    width: 11.47vw;
    height: 11.47vw;
  }

  .goods-info .box-info .info-item .img-box .img {
    margin: 0.27vw 0 0 0.93vw;
  }

  .goods-info .box-info .info-item .name-box {
    width: 20vw;

    padding-left: 4.27vw;
  }

  .goods-info .box-info .info-item .name-box .type {
    height: 4vw;
    line-height: 4vw;
    font-size: 3.33vw;
    margin-top: 2.4vw;
  }

  .goods-info .box-info .info-item .name-box .name {
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 2.67vw;
  }

  .goods-info .box-info .price-box {
    width: 37.07vw;
    height: 7.47vw;
    margin: 3.2vw 5.07vw 0 0;
  }

  .goods-info .box-info .price-box .price {
    height: 6.93vw;
    line-height: 6.93vw;
    font-size: 3.33vw;

    margin: 0.4vw 2.93vw 0 0.67vw;
  }

  .goods-info .box-info .price-box .coin {
    width: 3.87vw;
    height: 3.6vw;
    margin: 2vw 2.93vw 0 0;
  }

  .goods-info .box-info .total-box {
    width: 20.4vw;
    height: 6vw;
    font-size: 3.33vw;
    margin: 5.33vw 5.07vw 0 0;
  }

  .goods-info .box-info .total-box .pre-span {
    top: -4.67vw;

    width: 20.4vw;
    height: 4vw;
    line-height: 4vw;
  }

  .goods-info .box-info .total-box .total {
    width: 100%;
    height: 6vw;
    line-height: 6vw;
  }

  .goods-info .goods-list {
    width: 90.4vw;
    height: 86.13vw;
    margin: 5.6vw 0 5.87vw 4.93vw;
    padding: 1.6vw 0 0 2.4vw;
  }

  .goods-info .goods-list .list-inner {
    height: 81.2vw;
    overflow-y: scroll;
    padding: 2.67vw 0 0 0px;
  }

  .goods-info .goods-list .list-inner::-webkit-scrollbar {
    width: 0.67vw;
    height: 0.67vw;
  }

  .goods-info .goods-list .total-head {
    width: 84.53vw;
    height: 5.87vw;
    line-height: 5.87vw;
    span-align: center;
    font-size: 3.33vw;
    color: #bbc3ff;
    margin: 2vw 0 0.67vw 0.4vw;
  }

  .goods-info .goods-list .total-head .item2 {
    width: 20vw;
  }

  .goods-info .goods-list .total-head .item3 {
    width: 20vw;
  }

  .goods-info .goods-list .total-list {
    height: 72vw;

    padding: 0.27vw 0 0 0.4vw;
  }

  .goods-info .goods-list .total-list::-webkit-scrollbar {
    width: 0.67vw;
    height: 0.67vw;
  }

  .goods-info .goods-list .total-list .total-item {
    width: 84.53vw;
    height: 10.67vw;
    background-size: 100% 100%;
    margin: 0 0 1.07vw 0;
  }

  .goods-info .goods-list .total-list .total-item .item-column1 {
    position: relative;
    width: 14.13vw;
    margin-left: 1.33vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column1 .tag {
    position: absolute;
    left: 0.4vw;
    bottom: 0.4vw;
    height: 3.2vw;
    line-height: 3.2vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column2 {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 2.67vw;
    line-height: 4vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column2 .name {
    width: 25.33vw;
    height: 4vw;
    margin-top: 1.07vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column2 .price {
    height: 4vw;
    margin-top: 0.67vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column2 .price .coin {
    width: 3.87vw;
    height: 3.6vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column3 {
    width: 17.33vw;
    line-height: 4vw;
    span-align: right;
    padding-right: 0.67vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column3 .award {
    margin-top: 1.33vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column3 .num {
    margin-top: 0.4vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column4 {
    width: 17.33vw;
    line-height: 4vw;
    span-align: right;
    padding-right: 0.67vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column4 .award {
    margin-top: 1.33vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column4 .num {
    margin-top: 0.4vw;
  }

  .goods-info .goods-list .total-list .total-item .item-column5 {
    width: 4.27vw;
  }

  .prod-level {
    height: 11.33vw;

    font-size: 3.33vw;
  }

  .prod-level .pre-color {
    width: 2.67vw;
    height: 2.67vw;
    margin-right: 2.67vw;
    display: inline-block;
  }

  .prod-level .percentage {
    margin: 4.67vw 0 0 0;
  }

  .prod-level .percentage .level {
    width: 20vw;
  }

  .prod-level .level3 {
    padding-right: 2vw;
  }

  .prod-level .level2 {
    padding-right: 2vw;
  }

  .prod-level .level1 {
    padding-right: 2vw;
  }

  .prod-level .arr-progress {
    width: 83.47vw;
    height: 4.93vw;
    margin: 0.8vw 0 0 0px;
    padding: 1.53vw 0 0 1.87vw;
  }

  .prod-level .arr-progress .arr-item {
    width: 0.53vw;
    height: 1.33vw;
    margin-right: 0.27vw;
  }

  .prod-info {
    width: 28.13vw;
    height: 25.87vw;
    margin: 0 0.67vw 1.07vw 0;
  }

  .prod-info .img-box {
    width: 28.13vw;
    height: 19.33vw;
  }

  .prod-info .info-aw {
    bottom: 9.73vw;

    font-size: 3.33vw;
    padding: 0 0 0 1.33vw;
  }

  .prod-info .info-name {
    bottom: 5.73vw;

    height: 4.27vw;
    line-height: 4.27vw;
    padding: 0 1.33vw;
  }

  .prod-info .info-price {
    bottom: 0.8vw;
    right: 1.6vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 3.73vw;
  }

  .prod-info .info-price .coin {
    width: 3.87vw;
    height: 3.6vw;
  }

  .prod-info .tag-level {
    top: 0.8vw;

    width: 12.4vw;
    height: 4vw;
    line-height: 4vw;

    font-size: 3.33vw;
  }
}
</style>